import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LEGAL_ENTITY } from '../../constants/LegalEntity';
import { interpolateLegalText } from '../../utils/legalText';
import LegalPageLayout from '../../components/legal/LegalPageLayout';
import { BRAND } from '../../theme/brandTokens';

const LegalDocumentSections = ({ documentKey }) => {
  const { t } = useTranslation();
  const sections = t(`${documentKey}.sections`, { returnObjects: true, ...LEGAL_ENTITY });

  if (!Array.isArray(sections)) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="body1" sx={{ color: BRAND.text, lineHeight: 1.7 }}>
        {t(`${documentKey}.intro`, LEGAL_ENTITY)}
      </Typography>
      {documentKey === 'legal.privacy' && (
        <Typography variant="body1" sx={{ color: BRAND.text, lineHeight: 1.7, fontWeight: 600 }}>
          {t(`${documentKey}.contact`, LEGAL_ENTITY)}
        </Typography>
      )}
      {sections.map((section) => (
        <Box key={section.title}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, color: BRAND.primaryText, mb: 1.25 }}>
            {section.title}
          </Typography>
          {section.paragraphs.map((paragraph) => (
            <Typography
              key={paragraph}
              variant="body1"
              sx={{ color: BRAND.text, lineHeight: 1.7, mb: 1.25 }}
            >
              {interpolateLegalText(paragraph)}
            </Typography>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  return (
    <LegalPageLayout
      title={t('legal.privacy.title')}
      seoDescription={t('legal.privacy.seoDescription')}
      path="/privacy"
    >
      <LegalDocumentSections documentKey="legal.privacy" />
    </LegalPageLayout>
  );
};

export const CookiePolicyPage = () => {
  const { t } = useTranslation();
  return (
    <LegalPageLayout
      title={t('legal.cookies.title')}
      seoDescription={t('legal.cookies.seoDescription')}
      path="/cookies"
    >
      <LegalDocumentSections documentKey="legal.cookies" />
    </LegalPageLayout>
  );
};

export const TermsOfServicePage = () => {
  const { t } = useTranslation();
  return (
    <LegalPageLayout
      title={t('legal.terms.title')}
      seoDescription={t('legal.terms.seoDescription')}
      path="/terms"
    >
      <LegalDocumentSections documentKey="legal.terms" />
    </LegalPageLayout>
  );
};
